export default __webpack_public_path__ + "static/media/filter-line.4868dc48.svg";